import styled from 'styled-components';

export const UploadArea = styled.div<{ isDragOver: boolean }>`
  border: 2px dashed
    ${props =>
      props.isDragOver ? 'var(--color-primary-500)' : 'var(--color-gray-200)'};
  border-radius: var(--radius-lg);
  padding: 48px 24px;
  text-align: center;
  background-color: ${props =>
    props.isDragOver ? 'var(--color-primary-25)' : 'var(--color-gray-25)'};
  transition: var(--transition-normal);
  cursor: pointer;

  &:hover {
    border-color: var(--color-primary-500);
    background-color: var(--color-primary-25);
  }
`;

export const UploadIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-100);
  border-radius: var(--radius-full);
  color: var(--color-primary-500);
`;

export const UploadText = styled.div`
  margin-bottom: 8px;
`;

export const UploadMainText = styled.span`
  font-size: var(--font-size-16);
  color: var(--color-gray-700);

  .browse-link {
    color: var(--color-primary-500);
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: var(--color-primary-600);
    }
  }
`;

export const SupportedFormats = styled.p`
  font-size: var(--font-size-14);
  color: var(--color-gray-400);
  margin: 8px 0 4px 0;
`;

export const FileSizeLimit = styled.p`
  font-size: var(--font-size-14);
  color: var(--color-gray-400);
  margin: 0;
`;

export const SampleFileLink = styled.a`
  display: inline-block;
  font-size: var(--font-size-14);
  color: var(--color-primary-500);
  margin-top: 8px;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: var(--color-primary-600);
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
